export default "__VITE_ASSET__90465058__"